import "../scss/app.scss";
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
jQuery(document).ready(function ($) {
  $('.lazy').Lazy();
  $(window).on('scroll', () => {
    if (document.body.scrollTop > 140 || document.documentElement.scrollTop > 140) {
      $('.js-n-header-inner').addClass('n__header__inner--schrinked');
      $('.js-n-header').addClass('n__header--shrinked');
    } else {
      $('.js-n-header-inner').removeClass('n__header__inner--schrinked');
      $('.js-n-header').removeClass('n__header--shrinked');
    }
  });

  if (document.body.scrollTop > 140 || document.documentElement.scrollTop > 140) {
    $('.js-n-header-inner').addClass('n__header__inner--schrinked');
    $('.js-n-header').addClass('n__header--shrinked');
  }


  function toggleMobileNav() {
    $('.js-n-header-panel').toggleClass('n__header__panel--opened');
  };

  document.addEventListener('click', function (event) {
    if (event.target.closest('.n__header__panel--opened')) return;
    if(!$('.js-n-header-panel').hasClass('n__header__panel--opened')) return;
    toggleMobileNav();

}, false);
  
  $('.js-n-header-nav-toggle').click(e => {
    e.preventDefault();
    e.stopPropagation();
    toggleMobileNav();
  });
  $('.js-n-header-panel .menu-item-has-children > a').click(function(e) {
    if($(window).width() < 1450){
      e.preventDefault();
      $(this).parent().find('.sub-menu').addClass('n__header__sub__opened');
      $('.js-n-header-panel-sub-title').text($(this).text());
    }
  });
  $('.js-n-header-panel-sub-btn').click((e) => {
    e.preventDefault();
    e.stopPropagation();
    if($('.js-n-header-panel-sub-title').text()){
      $('.n__header__sub__opened').removeClass('n__header__sub__opened');
      $('.js-n-header-panel-sub-title').text('');
    } else {
      toggleMobileNav();
    }
  });

  $('.js-cookie-bar-btn').click(function(e){
    e.preventDefault();
    setCookie('cookies-accepted', 1, 365);
    $('.js-cookie-bar').remove();
  });
  

  $('.js-n-back-top').click(function(e){
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0}, 700);
  });

  if($('.js-n-text-slider').length){
    $('.js-n-text-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('.js-n-text-slider-prev'),
      nextArrow: $('.js-n-text-slider-next'),
      adaptiveHeight: true, 
      lazyLoad: 'ondemand'
    });
    $('.js-n-text-slider').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $('.js-n-text-slider-current').text(nextSlide + 1);
    });
  }

  if($('.js-images-slider').length){
    $('.js-images-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('.js-images-slider-prev'),
      nextArrow: $('.js-images-slider-next'),
      adaptiveHeight: true, 
      lazyLoad: 'ondemand'
    });
    $('.js-images-slider').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      $('.js-images-slider-current').text(nextSlide + 1);
    });
  }

  $('.js-n-sponsors-nav-item, .js-n-exhibitions-nav-item').click(function(e){
    e.preventDefault();
    const isMobile = $(window).width() < 768;
    const offset = isMobile ? 130 : $(this).parent().innerHeight() + 80;
    $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top - offset }, 700);
    window.location.hash = $(this).attr("href"); 
    if(isMobile){
      $(this).parents('.js-inner-menu-nav').slideToggle();
      $('.js-inner-menu-nav-toggle').removeClass('opened');
    }
  });

  if (window.location.hash.length !== 0) {
    if($(window.location.hash).length){
      const offset = $('.n__inner__menu').innerHeight() + 80;
      $("html, body").animate({ scrollTop: $(window.location.hash).offset().top - offset }, 700);
    }
  }

  $('.js-inner-menu-nav-toggle').click(function(e){
    e.preventDefault();
    if($(window).width() < 768){
      $('.js-inner-menu-nav').slideToggle();
      $(this).toggleClass('opened');
    }
  });



  if(typeof WOW !== 'undefined'){
    new WOW().init();
  }

  $('.js-copy-permalink-btn').click(function(e){
    e.preventDefault();
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(this).attr('href')).select();
    document.execCommand("copy");
    $temp.remove();
    alert($(this).data('cb'));
  });

  require('./quizes');
  require('./newsletter');
  require('./new-theme-form');
  require('./load-more-posts');
  require('./video-collection');
  // End of document ready
});